import { source } from '../constants';
import myFetchWithId, {exportWithId} from '../helpers/myFetch';
import { detailFormatToSample } from '../helpers/dataTransfer';
import { dateAndValue } from '../helpers/dateAndValue';
import { timestampConverter } from '../components/channelSearch/channelHelper';
import { requestFetchApi , receiveFetchApi } from './search.actions';

export function getSourceAndDate(keyword, sentiment, widgetId, isDashboard, posttype, voice, fieldname,justReturn = false) {
  let params = {
    text: keyword,
    fieldname,
    glb_posttype: posttype,
    glb_sentiment: sentiment,
    maxcount: -1,
    fillgap: 'Y',
    score: voice
  }

  if(isDashboard){
  }

  return dispatch => {
    isDashboard ? null : dispatch(requestFetchApi())
    return  myFetchWithId(widgetId, false, true)(process.env.REACT_APP_LOWI_MULTI, params)
    .then(json =>{
      isDashboard ? null : dispatch(receiveFetchApi(json,widgetId))
      return dispatch(receiveDateData(json,justReturn))
    })
    .catch(err => {
      isDashboard ? null : dispatch(receiveFetchApi(err,widgetId))
      console.log(err)
    })
  };
}

function receiveDateData(json,justReturn){
  return {
    type:source.RECEIVE_SOURCE_DATE,
    lineChartData: justReturn ? [] : lineChartDataProcess(json),
    receivedAt: Date.now()
  }
}

export function lineChartDataProcess(json){
  if(Object.keys(json.values).length === 0){
    return []
  }

  // 創造 highchart data 模板
  const EnToZh = {SM:'社群',NEWS:'新聞',BBS:'論壇',BLOG:'部落格'}
  const mediaType = Object.keys(json.values.tagValues).map(key=>{return {name:EnToZh[key] || key ,data:[]}})
  // 推送資料
  Object.values(json.values.tagValues).map((val,index)=>mediaType[index].data = val['@values'])

  //處理成 [timestamp ,val]
  mediaType.forEach((type,index)=>{
    let times = Object.keys(type.data).map(time=>[timestampConverter(time)])
    Object.values(type.data).forEach((val,index)=>{
        times[index].push(val)
    })
    
    mediaType[index].data = times
  })
  return mediaType
}

export function localFetchSource(keyword, sentiment, widgetId, isDashboard, posttype, voice, fieldname = 'glb_type,glb_source') {

  let params = {
    text: keyword,
    fieldname,
    glb_posttype: posttype,
    glb_sentiment: sentiment,
    maxcount: -1,
    fillgap: 'N',
    score: voice
  }
  // if we want todo something differently from non dashboard widget, we can add the or remove the params here
  if (isDashboard) {
    // delete params.glb_posttype;
    // delete params.glb_sentiment;
  }
  return dispatch => {
    isDashboard ? null : dispatch(requestFetchApi())
    return  myFetchWithId(widgetId, false, true)(process.env.REACT_APP_LOWI_MULTI, params)
    .then(json =>{
      isDashboard ? null : dispatch(receiveFetchApi(json,widgetId))
      return dispatch(receiveSource(json))
    })
    .catch(err => {
      isDashboard ? null : dispatch(receiveFetchApi(err,widgetId))
      console.log(err)
    })
  };
}

function receiveSource(detailJson) {
  const json = detailFormatToSample(detailJson, true);
  // 把object key當作name value拉出來
  const s_type = json.values.tagCounts ? Object.entries(json.values.tagCounts).map(([name, y]) => ({ name, y })) : [];

  const s_type_sort = s_type && s_type.sort(function (a,b) {
    return b.y - a.y;
  });

  // key拉出來給 media source 當作key
  const s_type_key = s_type_sort.map(type =>type.name);

  // 依據s_type的key 去找出相對應的頻道名稱跟值 再把name跟value拆開存放
  const s_source = s_type_key.map(type => {
    return json.values.tagValues[type] ? Object.entries(json.values.tagValues[type]).map(([name, y]) => ({ name, y })) :  [];
  });
  const s_source_sort = s_source.map(source => {
    return source.sort(function (a,b) {
      return b.y - a.y;
    });
  })

  // 將s_source 進行陣列扁平化
  const s_source_flat = Array.isArray(s_source) ?
    s_source.reduce(function (pre, cur) {
      return pre.concat(cur);
    }, []) : [];

  // transfer language
  const s_type_sort_transfer = s_type_sort.map( type => {
    switch (type.name) {
      case 'BBS':
        return ({name: '論壇', y: type.y});
      case 'KNOWLEDGE':
        return ({name: '知識', y: type.y});
      case 'NEWS':
        return ({name: '新聞', y: type.y});
      case 'SM':
        return ({name: '社群', y: type.y});
      case 'BLOG':
        return ({name: '部落格', y: type.y});
      case 'REMARK':
        return ({name: '點評', y: type.y});
      default:
        return ({name: type.name, y: type.y});
    }
  });

  return {
    type: source.RECEIVE,
    mediaType: s_type_sort_transfer,
    mediaSource: s_source_flat,
    fetched: true,
    typeReport: s_type_sort_transfer.map( (type, index) => {
      return ({
        type_name: type.name,
        type_value: type.y,
        source: s_source_sort[index].map(source =>{
          return ({
            source_name: source.name,
            source_value: source.y
          });
        })
      });
    }),
    // 拿取資料的widget的uid
    // targetWidgetId: uid,
    receivedAt: Date.now()
  }
}

export function exportMediaSource(keyword, sentiment, widgetId, isDashboard, posttype) {
  let params = {
    text: keyword,
    fieldname: 'glb_type,glb_source',
    glb_posttype: posttype,
    glb_sentiment: sentiment,
    maxcount: -1,
    score: 1
  };
  // if we want todo something differently from non dashboard widget, we can add the or remove the params here
  if (isDashboard) {
    delete params.glb_posttype;
    delete params.glb_sentiment;
  }
  return exportWithId(widgetId, false, true)(process.env.REACT_APP_EXPORT, params);
}







export function fetchSourceVibe(keyword, widgetId, isDashboard, posttype, sentiment, maxCount, voice, mediaType) {
  let params = {
    text: keyword,
    fieldname: 'glb_source,glb_sentiment',
    glb_posttype: posttype,
    glb_sentiment: sentiment,
    maxcount: maxCount,
    sorts: 'DocumentCount',
    fillgap: 'Y',
    score: voice
  };
  if(mediaType !== 'ALL'){
    console.log('select type : '+mediaType)
    params.replaceGlobalParams = true
    params.glb_type = mediaType
  }

  return dispatch => {
    isDashboard ? null : dispatch(requestFetchApi())
    return myFetchWithId(widgetId, false, true)(process.env.REACT_APP_LOWI_MULTI, params)
    .then(json =>{
      isDashboard ? null : dispatch(receiveFetchApi(json,widgetId))
      return dispatch(receiveSourceVibe(json, maxCount))
    })
    .catch(err => {
      isDashboard ? null : dispatch(receiveFetchApi(err,widgetId))
      console.log(err)
    })
  };
}


function receiveSourceVibe(detailJson, maxCount) {
  const json = detailFormatToSample(detailJson, true);

  let noData = !json.values.tagCounts || !json.values.tagValues;

  if (noData) {
    return {
      name: null,
      receivedAt: Date.now()
    };
  } else {
    let sourceName = Object.keys(json.values.tagCounts);
    let tagCounts = Object.entries(json.values.tagCounts).map(([name, y]) => ({ name, y }));
    let value = json.values.tagValues;
    let positive = [];
    let negative = [];
    let neutral = [];
    let dataForBubble = [];
    for (var prop in value) {
      positive.push(value[prop].POSITIVE);
      negative.push(value[prop].NEGATIVE);
      neutral.push(value[prop].NEUTRAL);
      dataForBubble.push({
        x: value[prop].NEGATIVE,
        y: value[prop].POSITIVE,
        z: value[prop].NEGATIVE + value[prop].POSITIVE + value[prop].NEUTRAL,
        neutral: value[prop].NEUTRAL,
        name: prop
      })
    };
    // if there is 'ANONYMOUS' indside the source return, take off it
    const index = sourceName.findIndex(name => name === 'ANONYMOUS');
    if (index !== -1) {
      sourceName.splice(index, 1);
      positive.splice(index, 1);
      negative.splice(index, 1);
      neutral.splice(index, 1);
      tagCounts.splice(index, 1);
      dataForBubble.splice(index, 1);
    } else {
      // if there is no ANONYMOUS, take off the last source
      sourceName.splice(maxCount -1 , 1);
      positive.splice(maxCount -1 , 1);
      negative.splice(maxCount -1 , 1);
      neutral.splice(maxCount -1 , 1);
      tagCounts.splice(maxCount -1 , 1);
      dataForBubble.splice(maxCount -1 , 1);
    }

    const computeAvg = (arr) => {
      let sum, avg = 0;
      if (arr.length) {
        sum = arr.reduce(function(p, c) { return p + c;});
        avg = sum / arr.length;
      }
      return avg;
    };

    return {
      type: source.RECEIVE,
      name: sourceName,
      kolTagCounts: tagCounts,
      kolPositive: positive,
      kolNegative: negative,
      kolNeutral: neutral,
      dataForBubble: dataForBubble,
      avgPositive: computeAvg(positive),
      avgNegative: computeAvg(negative),
      receivedAt: Date.now()
    }
  }
}

export function exportSourceVibe(keyword, widgetId, isDashboard, posttype, sentiment, maxCount, mediaType) {
  let params = {
    text: keyword,
    fieldname: 'glb_source,glb_sentiment',
    glb_posttype: posttype,
    glb_sentiment: sentiment,
    maxcount: maxCount,
    sorts: 'DocumentCount'
  };
  // if we want todo something differently from non dashboard widget, we can add the or remove the params here
  if (isDashboard) {
    delete params.glb_posttype;
    delete params.glb_sentiment;
  }
  console.log(mediaType)
  if(mediaType !== 'ALL'){
    console.log('select type : '+mediaType)
    params.replaceGlobalParams = true
    params.glb_type = mediaType
  }
  return exportWithId(widgetId, false, true)(process.env.REACT_APP_EXPORT, params);
}


export function fetchSourceDate(keyword, widgetId, isDashboard, posttype, sentiment, maxCount, voice, sdate, edate, mediaType) {
  let params = {
    text: keyword,
    fieldname: 'glb_source,GLBTIME_YMD',
    glb_posttype: posttype,
    glb_sentiment: sentiment,
    maxcount: maxCount,
    sorts: 'DocumentCount',
    fillgap: 'Y',
    score: voice
  };

  if(mediaType !== 'ALL'){
    console.log('select type : '+mediaType)
    params.replaceGlobalParams = true
    params.glb_type = mediaType
  }

  if (isDashboard) {
    delete params.glb_posttype;
    delete params.glb_sentiment;
  }

  return dispatch => {
    isDashboard ? null : dispatch(requestFetchApi()) 
    return myFetchWithId(widgetId, false, true)(process.env.REACT_APP_LOWI_MULTI, params)
    .then(json =>{
      isDashboard ? null : dispatch(receiveFetchApi(json,widgetId))
      return dispatch(receiveSourceDate(json, maxCount, sdate, edate))
    })
    .catch(err => {
      isDashboard ? null : dispatch(receiveFetchApi(err,widgetId))
      console.log(err)
    })
  };
}

function receiveSourceDate(detailJson, maxCount, sdate, edate) {
  const json = detailFormatToSample(detailJson, true);
  let noData = !json.values.tagCounts || !json.values.tagValues;

  if (noData) {
    return {
      value: null,
      receivedAt: Date.now()
    };
  } else {
    const data = json.values.tagValues;
    const payload = [];


    for (var prop in data) {
      let name = prop;
      let y = dateAndValue(data[prop], 'glbtime_YMD', sdate, edate);

      payload.push({
        name: name,
        data: y
      });

    };


    // if there is 'ANONYMOUS' indside the kol return, take off it
    const index = Object.keys(data).findIndex(name => name === 'ANONYMOUS');
    if (index !== -1) {
      payload.splice(index, 1);
    } else {
      payload.splice(maxCount-1, 1);
    }
    return {
      type:source.RECEIVE_MEDIA_SENTIMENT_VIBE,
      value: payload,
      receivedAt: Date.now()
    }
  }
}

export function exportSourceDate(keyword, widgetId, isDashboard, posttype, sentiment, maxCount,mediaType) {
  console.log(mediaType)
  let params = {
    text: keyword,
    fieldname: 'glb_source,GLBTIME_YMD',
    glb_posttype: posttype,
    glb_sentiment: sentiment,
    maxcount: maxCount,
    sorts: 'DocumentCount',
    soce: 1
    };
  // if we want todo something differently from non dashboard widget, we can add the or remove the params here
  if (isDashboard) {
    delete params.glb_posttype;
    delete params.glb_sentiment;
  }
  if(mediaType !== 'ALL'){
    console.log('select type : '+mediaType)
    params.replaceGlobalParams = true
    params.glb_type = mediaType
  }
  return exportWithId(widgetId, false, true)(process.env.REACT_APP_EXPORT, params);
}



// WEBPACK FOOTER //
// ./src/actions/widgetSource.actions.js